'use strict';

// Constructor
var PageScroll = function () {
    if ($('main.introduction').length > 0) {
        var $id = getUrlParam('id', 'none');
        if ($('#' + $id).length) {
            $("html, body").animate({ scrollTop: $('#' + $id).offset().top - 300 }, 1000);
        }
    }
    if ($('main.appendix').length > 0) {
        console.log('appendix');
        $("html, body").animate({ scrollTop: 0 }, 0); // Scroll page to top
        setTimeout(function () {
            if ($id = getUrlBookmark()) {
                $('a[name=' + $id + ']').length ? $("html, body").animate({ scrollTop: $('a[name=' + $id + ']').offset().top - 300 }, 1000) : '';
            }
        }, 100);


        $('main.appendix .text-block a[href^="#"]').click(function ($event) {
            $event.preventDefault();
            var url = $(this).attr('href')
            var $id = url.substring(url.indexOf("#") + 1);
            $('a[name=' + $id + ']').length ? $("html, body").animate({ scrollTop: $('a[name=' + $id + ']').offset().top - 300 }, 1000) : '';
        });
    }

    function getUrlParam(parameter, defaultvalue) {
        var urlparameter = defaultvalue;
        if (window.location.href.indexOf(parameter) > -1) {
            urlparameter = getUrlVars()[parameter];
        }
        return urlparameter;
    }

    function getUrlBookmark() {
        var url = window.location.href;
        if (url.indexOf('#') > -1) {
            var $id = url.substring(url.indexOf("#") + 1);
            return $id;
        }
        return false;
    }

    function getUrlVars() {
        var vars = {};
        var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
            vars[key] = value;
        });
        return vars;
    }
};

module.exports = PageScroll;
